module["exports"] = [
  "Rua",
  "Avenida",
  "Travessa",
  "Ponte",
  "Alameda",
  "Marginal",
  "Viela",
  "Rodovia"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/street_suffix.js
// module id = 1753
// module chunks = 0